import fetcher from 'api/fetcher';
import { NotificationName } from 'utils/constants/notification';

import urlParser from 'bloko/common/urlParser';

import { addNotification } from 'store/models/notification';
import { setLoadPayers, setPayers } from 'store/models/payers';

export default () => {
    return (dispatch, getState) => {
        const { filterType, filterValue, filterPayerType, filterWithoutAgreement } = getState().payers;
        const pathname = getState().router.location.pathname;

        const currentUrl = urlParser(pathname);
        if (!filterValue && !filterPayerType && !filterWithoutAgreement) {
            return dispatch(addNotification(NotificationName.PayersPageErrorEmptyValue));
        }

        const params = {};
        if (filterValue) {
            currentUrl.params.type = filterType;
            currentUrl.params.value = filterValue;
            params.type = filterType;
            params.value = filterValue;
        }
        if (filterPayerType) {
            currentUrl.params.payerType = filterPayerType;
            params.payerType = filterPayerType;
        }
        if (filterWithoutAgreement) {
            currentUrl.params.withoutAgreement = filterWithoutAgreement;
            params.withoutAgreement = filterWithoutAgreement;
        }
        window.history.replaceState(window.history.state, document.title, currentUrl.href);

        dispatch(setLoadPayers(true));

        const queryStr = urlParser.stringify(params);
        return fetcher
            .get(`/api/v1/backoffice/payers/?${queryStr}`)
            .then((payers) => {
                dispatch([setPayers(payers), setLoadPayers(false)]);
            })
            .catch(() => {
                dispatch([setPayers([]), setLoadPayers(false)]);
            });
    };
};
